<template>
    <LayoutMinimal v-if="isClaimsEnabled">
        <div id="zammad-feedback-form">
            <button
                v-if="loadFormFailed"
                class="btn-retry"
                @click="loadForm"
            >
                {{$t('retry')}}
            </button>
            <Spinner v-else/>
        </div>
        <button
            class="go-back"
            @click="$router.go(-1)"
        >
            {{ $t('go_back') }}
        </button>
    </LayoutMinimal>
</template>

<script>
import LayoutMinimal from "../layouts/LayoutMinimal";
import Spinner from "../components/Spinner";

export default {
    components: {
        LayoutMinimal,
        Spinner,
    },
    data(){
        return {
            loadFormFailed: false,
        }
    },
    beforeCreate() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
        document.head.appendChild(recaptchaScript)

        setTimeout(function (){
            let zammadScript = document.createElement('script')
            zammadScript.setAttribute('id', 'zammad_form_script')
            zammadScript.setAttribute('src', 'https://support.divasplay.com/assets/form/form.js')
            document.head.appendChild(zammadScript)
        }, 750)
    },
    mounted() {
        if (!this.isClaimsEnabled) {
            window.open("https://chatsupport.divasplay.com", "_self");
        }
        else{
            setTimeout(this.loadForm, 1250);
        }
        
    },
    computed: {
        isClaimsEnabled() {
            return process.env.VUE_APP_CLAIMS_ENABLED === "true"; // Se compara como string
        },
    },
    methods: {
        loadForm() {
            try {
                $('#zammad-feedback-form').ZammadForm({
                    messageTitle: this.$t('zammad_support.form.messageTitle'),
                    messageSubmit: this.$t('zammad_support.form.messageSubmit'),
                    messageThankYou: this.$t('zammad_support.form.messageThankYou'),
                    showTitle: true,
                    attachmentSupport: true,
                    // lang: 'es', // optional, <html lang="xx"> will be used per default
                    // modal: true,
                    attributes: [
                        {
                            display: 'Name',
                            name: 'name',
                            tag: 'input',
                            type: 'text',
                            placeholder: 'Your Name',
                            defaultValue: '',
                        },
                        {
                            display: 'Email',
                            name: 'email',
                            tag: 'input',
                            type: 'email',
                            required: true,
                            placeholder: 'Your Email',
                            defaultValue: (this.$auth && this.$auth.ready() && this.$auth.check()) ? this.$auth.user().email : null,
                        },
                        {
                            display: 'Message',
                            name: 'body',
                            tag: 'textarea',
                            required: true,
                            placeholder: 'Your Message...',
                            defaultValue: '',
                            rows: 7,
                        },
                        {
                            display: 'Attachments',
                            name: 'file[]',
                            tag: 'input',
                            type: 'file',
                            repeat: 3,
                        },
                    ]
                });
                this.loadFormFailed = false;
            } catch (e) {
                this.loadFormFailed = true;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/classes.scss";

.go-back{
    @extend %fresh-btn;

    border-radius: 5px;
    display: block;
    margin: 25px auto 5px auto;
}
</style>

<style lang="scss">
@import "../styles/classes.scss";

#zammad-feedback-form {
    .btn-retry {
        @extend %fresh-btn;
        
        display: block;
        margin: 0 auto;
        border-radius: 5px;
    }
    
    .form-group.zammad-form-group {
        > label, >textarea:placeholder-shown, >input:placeholder-shown {
            text-transform: capitalize;
        }
        
        >textarea, >input {
            font-family: "poppins", "d-din", "Raleway", sans-serif !important;
        }
    }

    .btn {
        @extend %fresh-btn;
        border-radius: 5px;
    }   
}
</style>